import { useState } from 'react';

import { SvgPath } from '@rbilabs/universal-components';
import { LayoutChangeEvent, View, useWindowDimensions } from 'react-native';
import Svg from 'react-native-svg';

import { primitive } from 'styles/constants';

export const CurvedBackground = ({
  height,
  backgroundColor,
  curveColor = primitive.$white,
}: {
  height: number;
  backgroundColor: string;
  curveColor?: string;
}) => {
  const { width: windowWidth } = useWindowDimensions();
  const [width, setWidth] = useState(windowWidth);

  const onLayout = (event: LayoutChangeEvent) => {
    const nextWidth = Math.round(event.nativeEvent.layout.width);
    if (nextWidth > 0) {
      setWidth(current => (current === nextWidth ? current : nextWidth));
    }
  };

  return (
    <View
      onLayout={onLayout}
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        width: '100%',
        height,
        backgroundColor,
      }}
    >
      <Svg viewBox={`0 0 ${width} ${height}`} width="100%" height={height}>
        <SvgPath
          fill={curveColor}
          d={`M0 ${height} H${width} V${height} C${0.8 * width} ${0.7 * height}, ${0.2 * width} ${
            0.7 * height
          }, 0 ${height}
      Z`}
        />
      </Svg>
    </View>
  );
};
